
<div class="full-width" *ngIf="_isReady ; else loading">
  
 <mat-grid-list [cols]="cols">
    <div>

      <mat-grid-tile *ngFor="let num of _indexes" >
       
        <div style="width: 10px">

             <mat-form-field>
              <input matInput value="{{num.value}}"  placeholder="{{num.name}}" (change)="onChangeCoordinate(num.X,num.Y,$event.target.value)">
            </mat-form-field>
        </div>
       
          
      </mat-grid-tile>
    </div>
  </mat-grid-list> 

</div>
<ng-template #loading>
<p>Carregando...</p>
</ng-template>

